import { render } from "./SignupForm.vue?vue&type=template&id=83066622"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"
script.render = render

export default script